// REACT
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";

//CSS
import './Header.css';

import { Bell } from 'lucide-react';
import { Mail } from 'lucide-react';
import user from "../../images/user.svg"
import getAvatar from "../../utils/avatarFormat"

const MobileHeader = ({ userName, openProfile }) => {
    const [lastScrollY, setLastScrollY] = useState(0);
    const [show, setShow] = useState(true);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);

    const controlHeader = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY !== 0) {
                setShow(false);
            } else if (window.scrollY === 0) {
                setShow(true);
            }
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', controlHeader);
        return () => {
            window.removeEventListener('scroll', controlHeader);
        };
    }, [lastScrollY]);

    return (
        <header className={`header-mobile ${show ? 'visible' : 'hidden'}`}>
            <div className="header-left" onClick={openProfile}>
                <span className="header-mobile__avatar">{getAvatar(userName)}</span>
            </div>
            <div className="header-right">
                <button className="icon-button" onClick={() => {
                    setIsChatOpen(!isChatOpen)
                }}>
                    {isChatOpen ? (
                        <NavLink
                            to="/">
                            <Mail color="#fff" size={24} />
                        </NavLink>
                    ) : (
                        <NavLink to="/correio">
                            <Mail color="#fff" size={24} />
                        </NavLink>
                    )}
                </button>
                <button className="icon-button" onClick={() => { setIsNotificationOpen(!isNotificationOpen) }}>
                    {isNotificationOpen ?
                        (<NavLink
                            to="/">
                            <Bell color="#fff" size={24} />
                        </NavLink>) :
                        (<NavLink
                            to="/notificacoes">
                            <Bell color="#fff" size={24} />
                        </NavLink>)}
                </button>

            </div>
        </header >
    );
}

export default MobileHeader;